import {
  actions,
  getBusinessGroupUserDatatableAsync,
  createNewBusinessGroupUserAsync,
  setBusinessGroupUserRoleAsync,
  getBusinessGroupUserDatatableExportedAsync,
  unlinkBusinessGroupUserAsync,
  createNewBusinessGroupAdminAsync,
  resendBusinessGroupUserWelcomeAsync,
} from './slices';

export const BusinessUsersActions = {
  ...actions,
  getBusinessGroupUserDatatableAsync,
  createNewBusinessGroupUserAsync,
  setBusinessGroupUserRoleAsync,
  getBusinessGroupUserDatatableExportedAsync,
  unlinkBusinessGroupUserAsync,
  createNewBusinessGroupAdminAsync,
  resendBusinessGroupUserWelcomeAsync,
};
